<template>
  <div class="psap-page">

    <div class="snapshot-list">

      <div class="tab-btns">
        <div
        v-on:click="onClickEventVideo" ontouchstart=""
        class="tab-btn">Event video</div>
        <div
        v-on:click="onClickLiveVideo" ontouchstart=""
        class="tab-btn">Live video</div>
      </div>

      <div class="snapshot-containers-wrapper scrollable -x scrollbar-hidden">

        <div
        ref="event-snapshot"
        class="snapshot-container">
          <CompPsapEventMedia v-on:onEventErr="eventErr"/>
        </div>

        <div
        ref="live-snapshot"
        class="snapshot-container">
          <comp-psap-live-snapshot></comp-psap-live-snapshot>
        </div>

      </div>

    </div>

    <div class="cards-container scrollable -y scrollbar-hidden">

      <comp-psap-card-site
      v-on:onClickSite="onClickSite"></comp-psap-card-site>

      <comp-psap-card-contacts
      v-on:onClickContact="onClickContact"></comp-psap-card-contacts>

      <comp-psap-card-dealer
      v-on:onClickDealer="onClickDealer"></comp-psap-card-dealer>

    </div>

    <comp-modal-contact
    v-if="modals.contact.isVisible"
    v-on:onClose="onCloseContactModal"
    v-bind:name="modals.contact.name"
    v-bind:phone="modals.contact.phone"
    v-bind:email="modals.contact.email"></comp-modal-contact>

    <comp-modal-map
    v-if="modals.map.isVisible"
    v-on:onClose="onCloseContactMap"
    v-bind:name="modals.map.name"
    v-bind:address="modals.map.address"
    v-bind:lat="modals.map.lat"
    v-bind:lng="modals.map.lng"></comp-modal-map>

  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
import CompModalContact from '@/components/CompModalContact'
import CompModalMap from '@/components/CompModalMap'
import CompPsapEventMedia from '@/components/CompPsapEventMedia'
import CompPsapLiveSnapshot from '@/components/CompPsapLiveSnapshot'
import CompPsapCardDealer from '@/components/CompPsapCardDealer'
import CompPsapCardSite from '@/components/CompPsapCardSite'
import CompPsapCardContacts from '@/components/CompPsapCardContacts'
export default {
  name: 'psap-page',
  components: {
    CompIcon,
    CompModalContact,
    CompModalMap,
    CompPsapEventMedia,
    CompPsapLiveSnapshot,
    CompPsapCardDealer,
    CompPsapCardSite,
    CompPsapCardContacts
  },
  computed: {
  },
  data: function () {
    return {
      modals: {
        contact: {
          isVisible: false,
          name: null,
          phone: null,
          email: null
        },
        map: {
          isVisible: false,
          name: null,
          address: null,
          lat: null,
          lng: null
        }
      }
    }
  },
  watch: {
  },
  created: function () {
  },
  methods: {
    onClickEventVideo: function () {
      let element = this.$refs['event-snapshot']
      if (element) {
        element.scrollIntoView({behavior: 'smooth'})
      }
    },
    onClickLiveVideo: function () {
      let element = this.$refs['live-snapshot']
      if (element) {
        element.scrollIntoView({behavior: 'smooth'})
      }
    },
    onClickDealer: function ({name, phone, email}) {
      this.openContactModal(name, phone, email)
    },
    onClickSite: function ({name, address, lat, lng}) {
      this.openContactMap(name, address, lat, lng)
    },
    onClickContact: function ({name, phone, email}) {
      this.openContactModal(name, phone, email)
    },
    openContactModal: function (name, phone, email) {
      this.modals.contact.name = name
      this.modals.contact.phone = phone
      this.modals.contact.email = email
      this.modals.contact.isVisible = true
    },
    closeContactModal: function () {
      this.modals.contact.isVisible = false
    },
    onCloseContactModal: function () {
      this.closeContactModal()
    },
    openContactMap: function (name, address, lat, lng) {
      this.modals.map.name = name
      this.modals.map.address = address
      this.modals.map.lat = lat
      this.modals.map.lng = lng
      this.modals.map.isVisible = true
    },
    closeContactMap: function () {
      this.modals.map.isVisible = false
    },
    onCloseContactMap: function () {
      this.closeContactMap()
    },
    eventErr: function () {
      this.onClickLiveVideo()
    }
  }
}
</script>

<style scoped>
.psap-page {
  /* common */
  background-color: #000;
  color: #fff;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /* style */
  box-shadow: 0 0 4px 0 hsla(0, 0%, 0%, 0.5);
}

.psap-page .header {
  /* common */
  background-color: #000;
  font-size: 0.7em;
  /* size */
  width: calc(100% - 2em);
  padding: 1em;
  /* text */
  text-transform: uppercase;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.psap-page .snapshot-list {
  /* size */
  max-width: 600px;
  width: 100%;
}

.psap-page .snapshot-list .tab-btns {
  /* size */
  width: 100%;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.psap-page .snapshot-list .tab-btns .tab-btn {
  /* common */
  background-color: #fff;
  color: #000;
  font-size: 0.8em;
  /* mouse */
  cursor: pointer;
  /* text */
  font-weight: bold;
  text-transform: uppercase;
  /* size */
  width: 50%;
  height: 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.psap-page .snapshot-list .tab-btns .tab-btn:hover {
  /* common */
  background-color: hsla(0, 0%, 90%, 1);
}

.psap-page .snapshot-list .snapshot-containers-wrapper {
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.psap-page .snapshot-list .snapshot-container {
  /* common */
  background-color: transparent;
  /* size */
  min-width: calc(100% - 0px);
  padding: 3px;
}

.psap-page .cards-container {
  /* common */
  background-color: #333;
  /* size */
  max-width: 600px;
  width: calc(100% - 6px);
  max-height: 400px;
  height: 100%;
  margin: 3px;
  /* position */
  position: relative;
}




.psap-page .action-btns {
  /* common */
  background-color: #000;
  font-size: 1em;
  /* size */
  width: 100%;
  min-height: 4em;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.psap-page .action-btns .disabled-text{
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
  color: #fff;
  opacity: 0;
  z-index: -1;
  /* text */
  font-weight: bold;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* size */
  border: 2px solid #fff;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  /* animation */
  transition: opacity .3s;
}
.psap-page .action-btns .disabled-text.red{
  background-color: hsla(0, 100%, 60%, 1);
  color: #fff;
}
.psap-page .action-btns .disabled-text.blue{
  background-color: hsla(202, 100%, 50%, 1);
  color: #fff;
}
.psap-page .action-btns .disabled-text.black{
  background-color: hsla(202, 100%, 0%, 1);
  color: #fff;
}
.psap-page .action-btns.disabled {
  /* mouse */
  pointer-events: none;
}
.psap-page .action-btns.disabled .disabled-text{
  /* common */
  opacity: 1;
  z-index: 1;
}
.psap-page .action-btns .action-btn {
  /* common */
  font-size: 1em;
  background-color: hsla(0, 0%, 100%, 1);
  color: hsla(0, 0%, 0%, 1);
  /* mouse */
  cursor: pointer;
  /* size */
  padding: 0 1em;
  width: calc(50% - 2em);
  min-height: 4em;
  border-right: 1px solid #000;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.psap-page .action-btns .action-btn:last-child {
  /* size */
  border-right-width: 0px;
}
.psap-page .action-btns .action-btn.red {
  /* common */
  color: hsla(0, 100%, 50%, 1);
}
.psap-page .action-btns .action-btn .btn-text {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: bold;
}
.psap-page .action-btns .action-btn:hover {
  /* common */
  background-color: hsla(0, 0%, 90%, 1);
}


.psap-page .answer-container {
  /* common */
  background-color: #777;
  /* size */
  width: calc(100% - 6px);
  max-height: 400px;
  height: 100%;
  margin: 3px;
  /* position */
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/pages/Psap/PsapPage.vue